<app-loader></app-loader>
<h2 mat-dialog-title>User Access</h2>
<mat-dialog-content class="mat-typography">
    <mat-card>
        <mat-card-content>
            <div >
                <mat-form-field class="fullWidth" appearance="outline">
                    <mat-label>Email Ids</mat-label>
                    <input matInput [(ngModel)]="emailIds" >
                    
                </mat-form-field>
                <mat-form-field class="fullWidth driveid-matInput" appearance="outline">
                    <mat-label>Shared Drive Ids</mat-label>
                    <input matInput [(ngModel)]="driveId">
                </mat-form-field>
            </div>
            <div *ngIf="isError" class="error-message-foremail">
                <mat-error>{{errorMessage}}</mat-error>
            </div>
            <div *ngIf="isSuccess" class="success-message-foremail">
                {{successMessage}}
            </div>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [disabled]="!(emailIds != '' && driveId != '')" (click)="getContentBySearch()" class="button-style">Submit</button>
    <button mat-raised-button mat-dialog-close [mat-dialog-close]="closeDialog" class="button-style" (click)="closeDialog = true">Close</button>
</mat-dialog-actions>